/**
 * Собирает URL аватара для <img src>.
 * Сервер хранит относительный путь вида api/account/avatars/{userId}.
 */
export function resolveAvatarUrl(imageUrl?: string | null): string | null {
  const raw = (imageUrl || '').trim();
  if (!raw) return null;
  if (/^(https?:\/\/|blob:|data:|capacitor:|file:)/i.test(raw)) {
    return raw;
  }
  const base = (process.env.VUE_APP_API_URL || '').replace(/\/?$/, '/');
  return `${base}${raw.replace(/^\//, '')}`;
}
